import { Grid2X2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useParamsSelector } from '@nablax/shared/utils';

import { selectSTLGeometryInstanceUntyped } from '../../stores/project/project.selectors';
import { InstanceName } from '../helpers/instance-name';
import { CrumbLink, CrumbRender } from '../ui/crumb-link';

export type HandleWithCrumb = {
  crumb?: CrumbRender;
};

export const ComponentsCrumb: CrumbRender = ({ match }) => {
  return (
    <CrumbLink match={match}>
      <Grid2X2 size={15} />
    </CrumbLink>
  );
};

export const GeometryClassCrumb: CrumbRender = ({ match }) => {
  const { t } = useTranslation();
  return (
    <CrumbLink match={match}>
      {t('geometryClasses.' + match.params.geometryClass, {
        count: 2,
      })}
    </CrumbLink>
  );
};

export const InstanceCrumb: CrumbRender = ({ match }) => {
  const instance = useParamsSelector(selectSTLGeometryInstanceUntyped, [
    match.params.geometryBaseName!,
  ]).withDefaults;

  return (
    <CrumbLink match={match}>
      <InstanceName
        name={instance.displayProperties.name}
        geometryClass={instance.className}
      />
    </CrumbLink>
  );
};
